import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reportplus',
  templateUrl: './reportplus.component.html',
  styleUrls: ['./reportplus.component.css']
})
export class ReportplusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
